<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.3" cx="24" cy="24" r="20" fill="#4ABB89" />
    <path
      d="M31.6505 16.4714C31.7643 16.3379 31.9033 16.2282 32.0595 16.1485C32.2157 16.0688 32.3861 16.0207 32.5609 16.0068C32.7358 15.9929 32.9116 16.0136 33.0784 16.0677C33.2452 16.1218 33.3998 16.2082 33.5332 16.322C33.6666 16.4358 33.7763 16.5748 33.856 16.731C33.9357 16.8872 33.9839 17.0576 33.9978 17.2324C34.0116 17.4073 33.9909 17.5831 33.9368 17.7499C33.8828 17.9167 33.7963 18.0713 33.6825 18.2047L22.3492 31.538C22.2342 31.6733 22.0934 31.7842 21.9349 31.8644C21.7765 31.9445 21.6037 31.9921 21.4266 32.0045C21.2495 32.017 21.0717 31.9939 20.9036 31.9367C20.7355 31.8795 20.5806 31.7893 20.4479 31.6714L14.4479 26.338C14.1835 26.1031 14.0234 25.7727 14.0026 25.4196C13.9819 25.0666 14.1022 24.7197 14.3372 24.4554C14.5722 24.191 14.9025 24.0309 15.2556 24.0101C15.6087 23.9894 15.9555 24.1097 16.2199 24.3447L21.1999 28.766L31.6505 16.4714Z"
      fill="#4ABB89"
    />
  </svg>
</template>
